import { Select } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { FormItem } from 'components'
import { CUSTOM_FORM_DOCUMENTS_OPTIONS } from 'components/tools/CustomForm/constants'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type QuestionProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function EntityKindDocuments({ formMethods }: QuestionProps) {
  return (
    <FormItem isRequired label="Tipo de documento">
      <Select placeholder="Selecione um tipo de documento" {...formMethods.register('entity')}>
        {CUSTOM_FORM_DOCUMENTS_OPTIONS.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </FormItem>
  )
}
